import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  addLabelButton: {
    borderRadius: "6px",
    background: colors.veryLightGrey,
    padding: "2px 8px",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    width: "max-content",
  },
  addLabelButtonRounded: {
    borderRadius: "16px",
    padding: "4px 12px",
    
  },
  selectedLabelButton: {
    borderRadius: "6px",
    background: colors.white,
    border: "1px solid" + colors.darkGrey,
    boxShadow: "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
    padding: "2px 8px",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    width: "max-content",
  },
  selectedLabelButtonRounded: {
    borderRadius: "16px",
    padding: "4px 12px",
  },
  dropdownContainer: {
    borderRadius: "8px",
    border: "1px solid " + colors.veryLightGrey,
    background: colors.white,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
    width: "250px",
    zIndex: 2,
    "& .popover-arrow": {
      display: "none",
    },
  },

  inputContainer: {
    "& input": {
      height: "44px",
      width: "100%",
      border: "none",
      borderRadius: "8px",
      padding: "9px 10px",
      "&:focus": {
        outline: "none"
      }
    },
  },
  dividerContainer: {
    alignItems: "center",
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: 0,
  },
  label: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "14px",
    fontWeight: 500,
    color: colors.grey,
    marginTop: "2px",
    padding: "7px 10px",
    cursor: "pointer",
    "&:hover": {
      border: "none",
      backgroundColor: colors.brightBlue,
      borderRadius: "6px",
    },
  },
  spinnerContainer: {
    height: "40px",
    paddingTop: "12px",
  },
  labelsContainer: {
    maxHeight: "232px",
    overflow: "scroll",
    padding: "0 6px 2px",
  },
  labelSelected: {
    border: "none",
    backgroundColor: colors.brightBlue,
    borderRadius: "6px",
  },
  createNewContainer: {
    display: "flex",
    alignItems: "center",
    padding: "9px 10px",
    cursor: "pointer",
    "& svg": {
      color: colors.grey,
    }
  },
  disabledCreateButton: {
    cursor: "initial",
    "& span": {
      color: colors.paleGrey
    },
    "& svg": {
      color: colors.paleGrey
    }
  },
  inlineText: {
    fontSize: "14px",
    fontWeight: 500,
    color: colors.grey,
    wordBreak: "break-word",
    whiteSpace: "normal",
    marginLeft: "8px",
  },
  inputValueText: {
    fontSize: "14px",
    fontWeight: 500,
    marginLeft: "2px",
    color: colors.inactiveGrey,
  },
  icon: {
    padding: "2px",
  },
  labelName: {
    padding: "3px 0",
  },
}));

export default styles;
